import type { Messages } from './en.js'

// Draft translations for UI chrome (Traditional Chinese), pending professional
// review in Tolgee.
export const tw: Messages = {
  'common.needHelp': '需要協助嗎？',
  'common.continue': '繼續',
  'common.back': '返回',

  'shell.cookiePolicy': 'Cookie 政策',
  'shell.privacyPolicy': '隱私權政策',
  'shell.cookiePreferences': 'Cookie 偏好設定',
  'shell.language': '語言',

  'login.title': '登入',
  'login.subtitle': '請使用您帳戶所綁定的電子郵件。',
  'login.forgot': '忘記密碼？',
  'login.createAccount': '建立帳戶',

  'forgot.title': '重設密碼',
  'forgot.subtitle': '我們會將 6 位數驗證碼寄到您的電子郵件，以便設定新密碼。',
  'forgot.newTitle': '設定新密碼',
  'forgot.backToSignIn': '返回登入',

  'consent.message': '我們使用 Cookie 來運作本網站，並在取得您的同意後用於評估與改善。',
  'consent.acceptAll': '全部接受',
  'consent.essentialOnly': '僅必要',

  'common.email': '電子郵件',
  'common.password': '密碼',
  'common.tryAgain': '再試一次',
  'err.tooManyAttempts': '嘗試次數過多',
  'err.checkFailed': '驗證失敗',
  'err.otpDeliveryFailed': '我們無法寄送驗證碼',
  'err.otpLocked': '輸入錯誤驗證碼次數過多',
  'err.otpExpired': '此驗證碼已過期',
  'err.countryNotPermitted': '您的國家/地區無法使用',
  'err.temporarilyUnavailable': '暫時無法使用',
  'err.checkAnswers': '請檢查您的答案',
  'err.somethingWrong': '發生錯誤',

  'step.account': '帳戶',
  'step.identity': '身分驗證',
  'step.compliance': '合規',
  'step.finish': '完成',

  'account.emailTitle': '開立您的帳戶',
  'account.emailSubtitle': '我們會將 6 位數驗證碼寄到您的電子郵件以確認地址。',
  'account.botFailedTitle': '機器人驗證未載入',
  'account.botFailedBody': '您仍可繼續 — 我們會在您送出時確認。',
  'account.send': '寄送驗證碼',
  'account.sending': '寄送中…',
  'account.haveAccount': '已經有帳戶了？',
  'account.login': '登入',
  'account.otpTitle': '輸入您的驗證碼',
  'account.otpSentTo': '已寄送至 {target}。',
  'account.otpTargetFallback': '您的電子郵件',
  'account.escalated': '我們已透過其他供應商寄送另一組驗證碼。',
  'account.startAgain': '重新開始',
  'account.checking': '檢查中…',
  'account.verify': '驗證',
  'account.resend': '重新寄送驗證碼',
  'account.tryAnotherWay': '我沒有收到 — 換個方式',
  'account.differentEmail': '使用其他電子郵件',
  'account.profileTitle': '幾項資料',
  'account.profileSubtitle': '這是帳戶設定的最後一步。',
  'account.emailReadonlyHint': '已透過您剛輸入的驗證碼確認。',
  'account.country': '居住國家/地區',
  'account.countrySearch': '搜尋國家/地區',
  'account.phone': '電話',
  'account.consentBefore': '我同意依據以下政策收集及使用我的個人資料：',
  'account.consentAfter': '，並瞭解我可能會因申請事宜被聯絡。',
  'account.creating': '建立中…',
  'account.existsTitle': '您已經有帳戶',
  'account.signInInstead': '改為登入',

  'partner.add': '有合作夥伴代碼嗎？',
  'partner.label': '合作夥伴代碼 / Link ID',
  'partner.confirm': '套用代碼',
  'partner.remove': '移除',
  'partner.close': '關閉合作夥伴代碼',
  'partner.referredBy': '推薦人',
  'partner.partnerId': '合作夥伴編號',
  'partner.country': '國家/地區',
  'partner.unavailable': '無法驗證該代碼，請再試一次。',

  'identity.notReadyTitle': '請先完成您的帳戶',
  'identity.backToStep1': '返回步驟 1',
  'identity.title': '驗證您的身分',
  'identity.subtitle': '法規要求我們在您交易前確認您的身分，約需兩分鐘。',
  'identity.startFailedTitle': '無法開始驗證',
  'identity.step1': '請準備好您的護照、身分證或駕照。',
  'identity.step2': '您將拍攝證件照片，然後拍一張簡短的自拍。',
  'identity.step3': '當瀏覽器詢問時請允許使用相機 — 沒有相機無法進行驗證。',
  'identity.starting': '開啟中…',
  'identity.start': '開始驗證',
  'identity.partnerNote': '您將被帶往我們的驗證合作夥伴，並會立即返回此頁。',
  'identity.inProgress': '您已開始。繼續將從您上次的進度接續。',
  'webview.title': '請在您的瀏覽器中開啟此頁面',
  'webview.cameraWarn': '相機通常無法在 {browser} 中運作，而身分驗證需要相機。',
  'webview.namedBrowser': '{app} 的內建瀏覽器',
  'webview.thisBrowser': '此應用程式的內建瀏覽器',
  'webview.iosInstruction': '點選分享圖示，然後選擇 Open in Safari。',
  'webview.openInChrome': '在 Chrome 開啟',
  'webview.androidInstruction': '或使用選單並選擇 Open in browser。',
  'webview.otherInstruction': '將此頁面的網址複製到您平常使用的瀏覽器。',

  'confirm.title': '確認您的資料',
  'confirm.subtitle': '我們已從您的證件填入這些資料 — 請確認是否正確並修正有誤之處。',
  'confirm.saveFailedTitle': '無法儲存您的資料',
  'confirm.idOutstandingTitle': '我們仍需要您的證件',
  'confirm.idOutstandingBody':
    '您的身分驗證尚未完成，請於下方填寫您的資料。請繼續完成申請 — 我們會以電子郵件與您聯繫證件事宜。',
  'confirm.firstName': '名字',
  'confirm.lastName': '姓氏',
  'confirm.dob': '出生日期',
  'confirm.whereLive': '您居住在哪裡？',
  'confirm.city': '城市',
  'confirm.state': '州 / 省',
  'confirm.saving': '儲存中…',

  'compliance.stillCheckingTitle': '我們仍在檢查您的證件',
  'compliance.backToVerification': '返回驗證',
  'compliance.loading': '正在載入您的問卷…',
  'compliance.loadFailedTitle': '我們無法載入問卷',
  'compliance.stillStuck': '仍有問題？',
  'compliance.title': '最後幾個問題',
  'compliance.subtitle': '法規要求我們在開立帳戶前詢問這些問題。您的答案會與申請一併存檔。',
  'compliance.submitting': '送出中…',
  'compliance.submit': '送出',
  'compliance.oneQuestionLeft': '還有 1 個問題需要回答。',
  'compliance.questionsLeft': '還有 {count} 個問題需要回答。',
  'compliance.saveAnswersFailed': '我們無法儲存您的答案',

  'gate.stepToFinishTitle': '有一個步驟需要先完成',
  'gate.continueWhereLeft': '從上次的進度繼續',

  'done.loadingDocs': '正在載入最後幾份文件…',
  'done.loadFailedTitle': '我們無法載入您的文件',
  'done.tryAgainMoment': '請稍後再試。',
  'done.title': '最後一件事',
  'done.readyToSubmit': '您的申請已可送出。',
  'done.pleaseAccept': '在我們為您開立帳戶前，請閱讀並接受這些文件。',
  'done.agreeAll': '我已閱讀並同意全部 {count} 份文件',
  'done.hideDocs': '隱藏文件',
  'done.showDocs': '顯示 {count} 份文件',
  'done.version': '版本 {version}',
  'done.finishing': '完成中…',
  'done.finishSignIn': '完成並登入',
  'done.oneLeft': '還有 1 份文件需要您接受。',
  'done.docsLeft': '還有 {count} 份文件需要您接受。',
  'done.straightIn': '我們會直接帶您進入帳戶 — 無需再次登入。',
  'done.completeFailed': '我們無法完成您的申請',
  'done.acceptEvery': '請接受每一份文件',
  'done.getApps': '取得交易應用程式',
  'done.getAppsSubtitle': '帳戶開通後，您將透過 MT5 或 KCM Trade 應用程式進行交易。',
  'done.onComputer': '正在使用電腦嗎？',
  'done.scanQr': '掃描 QR 碼',
  'done.scanQrSuffix': '即可在手機上取得應用程式。',

  'kyc.approvedTitle': '身分已確認',
  'kyc.approvedBody': '謝謝 — 最難的部分已完成。',
  'kyc.reviewTitle': '我們正在審核您的文件',
  'kyc.reviewBody':
    '專人正在審核 — 通常需要幾小時，完成後我們會立即以電子郵件通知您。無需在此等待：請繼續完成其餘部分。',
  'kyc.questions': '有問題嗎？',
  'kyc.declinedTitle': '我們無法驗證您的身分',
  'kyc.contactPrefix': '請聯絡',
  'kyc.contactSuffix': '我們會接手處理。',
  'kyc.expiredTitle': '該工作階段已逾時',
  'kyc.expiredBody': '驗證工作階段開啟的時間不長。重新開始只需幾分鐘。',
  'kyc.continueAnyway': '繼續您的申請',
  'kyc.finishLaterBody':
    '您現在可以完成申請的其餘部分。我們會另外以電子郵件與您聯繫證件事宜，在此之前您的帳戶將維持待處理狀態。',
  'decline.document_unreadable': '您的證件照片不夠清晰而無法辨識。改善光線並放在平面上通常可解決。',
  'decline.face_mismatch': '自拍與證件上的照片不符。',
  'decline.document_expired': '您使用的證件已過期。',
  'decline.other': '自動化檢查無法確認您的身分。',

  'verify.checkFailedTitle': '我們無法檢查您的狀態',
  'verify.checkFailedBody': '您的驗證已送出。重新整理此頁面通常即可解決。',
  'verify.refresh': '重新整理',
  'verify.stillProcessingTitle': '仍在處理中',
  'verify.stillProcessingBody':
    '這比平常花更久時間。您的文件已送出且不會遺失 — 一有結果我們會立即以電子郵件通知您。',
  'verify.back': '返回',
  'verify.checkingTitle': '正在檢查您的文件',
  'verify.checkingBody': '這通常只需幾秒鐘。請勿關閉此頁面。',
  'verify.checkingAria': '正在檢查您的驗證',
  'handoff.receivedTitle': '已收到文件',
  'handoff.receivedBody': '謝謝 — 這是我們從您手機需要的全部資料。',
  'handoff.goBackTitle': '現在請回到您的電腦',
  'handoff.goBackBody':
    '您的申請仍在您開始的瀏覽器中開啟。請在那裡完成 — 驗證完成後頁面會自動繼續。',
  'handoff.closeTab': '您可以關閉此分頁。',
  'handoff.somethingWrong': '有什麼不對嗎？',
}
